// Generated with util/create-component.js
import React, { useCallback, useEffect, useRef, useState } from "react";
import LocationPin from "../../../assets/img/location_on_icon.svg";
import { useOutsideClickDetection } from "../../hooks/useDetectClickOutside";
import styles from "./InputBoxSelection.module.scss";
import { ILocation, InputBoxSelectionProps } from "./InputBoxSelection.types";

export const InputBoxSelection: React.FC<InputBoxSelectionProps> = ({
  dataList,
  placeholder,
  userSelectedData,
  showChips = false,
  setUserSelectedData,
  multipleSelection = true,
  inputValueSearch,
  onChangeInputSearch,
  handleUserSelection
}) => {
  const [showDataList, setShowDataList] = useState(false);
  const [checkedBoxes, setCheckedBoxes] = useState([]);
  const [showReducedChips, setShowReducedChips] = useState(false);

  const wrapperRef = useRef(null);
  const inputSearch = useRef(null);

  const handleMultipleCheckbox = (event: React.ChangeEvent<HTMLInputElement>, item: any, itemObj: any) => {
    const selectedBoxes = [...checkedBoxes];

    if (event.target.checked) {
      selectedBoxes.push(item);
    } else {
      const index = checkedBoxes.findIndex((ch) => ((ch === item)));
      selectedBoxes.splice(index, 1);
    }
    setCheckedBoxes(selectedBoxes);
    setUserSelectedData(selectedBoxes);
  };

  const handleSingleCheckbox = (event: React.ChangeEvent<HTMLInputElement>, item: any, itemObj: any) => {

    if (event.target.checked) {
      setUserSelectedData([item])
    }
    setCheckedBoxes([item]);
  };

  const handleSelectItem = (event, item: any, itemObj: any) => {
    handleUserSelection(item, itemObj)
    setUserSelectedData([item])
    onChangeInputSearch("")
    setShowDataList(false)
  }

  const handleRemoveSelection = (item: any) => {
    const newBoxes = checkedBoxes.filter((selection) => selection !== item)
    setCheckedBoxes(newBoxes);
    setUserSelectedData(newBoxes);
    handleUserSelection(null, null)
  };

  const handleOutsideClick = () => {
    setShowReducedChips(true);
    setShowDataList(false);
    inputSearch.current.value = "";
  };

  const renderChips = () => {
    return (
      showReducedChips &&
        checkedBoxes.length > 0 ? (
        <div className={styles.chipsContainer}>
          <div className={styles.chips}>
            <p>
              {checkedBoxes[0]}
            </p>
            <button
              className={styles.chips__closeButton}
              onClick={() => handleRemoveSelection(checkedBoxes[0])}
            >
              X
            </button>
          </div>
          {checkedBoxes.length >= 2 && <span>+ {checkedBoxes.length - 1} {`cidade${checkedBoxes.length > 2 ? 's' : ''}`}</span>}
        </div>
      ) : checkedBoxes &&
      checkedBoxes.map((item) => {
        return (
          <div key={item} className={styles.chipsContainer}>
            <div className={styles.chips}>
              <p>
                {item}
              </p>
              <button
                className={styles.chips__closeButton}
                onClick={() => handleRemoveSelection(item)}
              >
                X
              </button>
            </div>
          </div>
        );
      })
    )
  };

  useOutsideClickDetection(wrapperRef, handleOutsideClick);

  const itemChecked = (item) => {
    if (checkedBoxes.find((element) => element === item)) {
      return true
    }
    return false
  }

  useEffect(() => {
    setCheckedBoxes(userSelectedData)
  }, [userSelectedData])

  useEffect(() => {
    inputValueSearch?.length > 0 ? setShowDataList(true) : setShowDataList(false);
  }, [inputValueSearch])

  return (
    <div
      className={styles.formGroup}
      onClick={() => {
        inputSearch.current.focus();
        setShowReducedChips(false);
      }}
    >
      <div className={styles.inputContent}>
        <img src={LocationPin} alt="location" className={styles.inputContent__img} />
        {showChips && renderChips()}
        <input
          type="text"
          id="search"
          name="search"
          placeholder={placeholder || "Digite aqui..."}
          value={inputValueSearch}
          onChange={(e) => onChangeInputSearch(e)}
          ref={inputSearch}
          autoComplete="off"
        />
      </div>

      {showDataList && (
        <div className={styles.boxInputs} ref={wrapperRef}>
          {dataList.length <= 0 && (
            <p>Não encontrado</p>
          )}
          <ul className={styles.matchList}>
            {dataList?.map((item) => (
              <div key={`${item.id}-${item.category}`}>
                <li className={styles.checkbox}>
                  {multipleSelection ? (
                    <>
                      <input
                        autoComplete="off"
                        type="checkbox"
                        value={`${item.category}`}
                        name={`${item.category}`}
                        checked={itemChecked(item.category)}
                        onChange={(event) => {
                          multipleSelection
                            ? handleMultipleCheckbox(event, item.category, item)
                            : handleSingleCheckbox(event, item.category, item)
                        }}
                      />
                      <p>
                        {item.category}
                      </p>
                    </>

                  ) : (
                    <p
                      style={{ fontSize: '1.1rem' }}
                      onClick={(event) => {
                        handleSelectItem(event, item.category, item)
                      }}
                    >
                      {item.category}
                    </p>
                  )}
                </li>

                {item.items.map((el) => (
                  <li key={`${el}`} className={styles.list__items}>
                    {
                      multipleSelection ? (
                        <>
                          <input
                            autoComplete="off"
                            type="checkbox"
                            value={`${el}`}
                            name={`${el}`}
                            checked={itemChecked(el)}
                            onChange={(event) => {
                              multipleSelection
                                ? handleMultipleCheckbox(event, el, item)
                                : handleSingleCheckbox(event, el, item)
                            }}
                          />
                          <p>
                            {el}
                          </p>
                        </>
                      ) : (
                        <p onClick={(event) => {
                          handleSelectItem(event, el, item)
                        }}
                        >
                          {el}
                        </p>
                      )
                    }
                  </li>
                ))}
              </div>
            ))}
          </ul>
        </div>
      )}

      {!showChips && userSelectedData?.length > 0 && (
        <div className={styles.userSelection}>
          {checkedBoxes.map((data) => (
            <div key={data} className={styles.userSelection__content}>
              <p>
                {data}
              </p>
              <button
                className={styles.chips__closeButton}
                onClick={() => handleRemoveSelection(data)}
              >
                X
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
